export const title = {
  margin: "1.75rem 0 0.875rem",
  fontWeight: 700,
  fontFamily: `"Roboto Slab", "Times New Roman", serif`,
};
